const theme = require('norska/theme');
const transforms = require('./_scripts/transforms.js');
const config = require('./_scripts/config.js');

(async () => {
  const { credentials, sidebar } = config;
  await theme.init({
    placeholder: 'Search for any NPC, Location, Author, etc...',
    hitName: 'scenario',
    credentials,
    sidebar,
    transforms,
  });
})();
